import PropTypes from 'prop-types'

const FieldTimeCoverInput = ({
                                 id,
                                 type,
                                 placeholder,
                                 iconBefore,
                                 iconAfter,
                                 wrapperClasses,
                                 inputClasses,
                                 field,
                                 max,
                                 disabled,
                                 iconUp,
                                 iconDown,
                                 timeIncrement,
                                 timeDecrement,
                                 min,
                                 unit,
                                 beforePlaceholder = '',
                                 form: {touched, errors}
                             }) => {
    return (
        <div className={wrapperClasses}>
            <div
                className="field input-group flex justify-between items-center w-full  mb-2 shadow bg-white rounded-md">
                {beforePlaceholder !== '' && <span className="text-black">{beforePlaceholder}</span>}
                <input
                    value={field.value || ''}
                    id={id}
                    type={type}
                    disabled={!!disabled}
                    max={max}
                    min={min}
                    className={`w-full h-full py-1.5 px-2 pl-2 text-gray-700 leading-tight focus:outline-none bg-white focus:shadow-outline` + inputClasses}
                    placeholder={placeholder}
                    {...field}
                />
                <div className="flex justify-center items-center bg-white pr-3">
                    <span className="text-sm">{unit}</span>
                </div>
                <div className="increment-decrement-control">
                    <div>
                         <span
                             onClick={() => timeIncrement()}
                             className="text-black">
                        {iconUp}
                    </span>
                    </div>
                    <div>
                          <span
                              onClick={() => timeDecrement()}
                              className="text-black">
                    {iconDown}
                    </span>
                    </div>
                </div>
            </div>
            {touched[field.name] &&
                <p className="text-red-500 text-xs italic">{errors[field.name]}</p>
            }
        </div>
    )
}

export default FieldTimeCoverInput

FieldTimeCoverInput.propTypes = {
    type: PropTypes.string,
    id: PropTypes.string,
    placeholder: PropTypes.string,
    iconBefore: PropTypes.element,
    iconAfter: PropTypes.element,
    iconUp: PropTypes.element,
    iconDown: PropTypes.element,
    field: PropTypes.object,
    form: PropTypes.object,
    max: PropTypes.number,
    min: PropTypes.number,
    disabled: PropTypes.bool,
    wrapperClasses: PropTypes.string,
    inputClasses: PropTypes.string,
    timeIncrement: PropTypes.func,
    timeDecrement: PropTypes.func,
    unit: PropTypes.string,
    beforePlaceholder: PropTypes.string
}

